import React, { useEffect, useState, useRef }  from 'react';
import Draggable from 'react-draggable';
import InfiniteScroll from 'react-infinite-scroll-component';
import moment from 'moment';

import LibraryControlDetails from '../control_library/library_control_details';
import UnwantedEventDescription from '../../components/controls_component/unwanted_event_description';

import { getText } from '../../helpers';
import useApiService from '../../services/useApiService';

import './plan_default_template_control_logs_modal.css'


function useDidUpdateEffect(fn, inputs) {
  const isMountingRef = useRef(false);

  useEffect(() => {
    isMountingRef.current = true;
  }, []);

  useEffect(() => {
    if (!isMountingRef.current) {
      return fn();
    } else {
      isMountingRef.current = false;
    }
  }, inputs);
}

const LibraryControlItem = (props) => {
  const { libraryControl } = props;
  const [ controlDetailsShown, setControlDetailsShown ] = useState(false);
  
  const toggleCompleteDetails = () => {
    setControlDetailsShown(!controlDetailsShown)
  }

  return (
    <div className='control-details library-control-details'>
      <div>
        <span className='dynamic-custom-id link' onClick={toggleCompleteDetails}>{libraryControl.custom_id}</span>
        <span className='control-title'>{libraryControl.title}</span>
        <span> / </span>
        <span className='control-subtitle'>{libraryControl.subtitle}</span>
      </div>
      {
        controlDetailsShown &&
        <LibraryControlDetails control={libraryControl} hideLibControlDetails={toggleCompleteDetails}/>
      }
    </div>
          
    );
}

const PlanDefaultTemplateControlLogsModal = (props) => {
  const { planId } = props;
  const perPage = 15;
  const [ logs, setLogs ] = useState([]);
  const [ page, setPage] = useState(1);
  const [ logId, setLogId ] = useState(null);
  
  const [{ response: fetchedLogs }, getLogs] = useApiService({ url: `/plans/${planId}/default_template_control_logs`, defaultResponse: [] });
  const [{ response: markedLogAsReviewed }, markLogAsReviewed] = useApiService({ url: `/default_template_control_logs/${logId}/mark_as_reviewed`, method: "put", onMount: false});
  
  const setNewPage = () => {
    if (fetchedLogs.length < perPage) return;
    setPage(page + 1)
  }

  useEffect(()=>{
    getLogs({ params: { per_page: perPage, page } });
  }, [page])

  useEffect(()=>{
    if (page === 1) return setLogs(fetchedLogs);
    setLogs(logs.concat(fetchedLogs));
  }, [fetchedLogs])

  useDidUpdateEffect(()=>{
    markLogAsReviewed()
  }, [logId])

  useDidUpdateEffect(()=>{
    if (page > 1) return setPage(1);
    getLogs({ params: { per_page: perPage, page } });
  }, [markedLogAsReviewed])

  const markAsReviewed = (logId) => {
    setLogId(logId)
  }

  const createLogDescription = (log) => {
    const { user, control, tag_list: tagList } = log;
    const { profile, email } = user || {};
    const { first_name: firstName, last_name: lastName } = profile || {};

    const { library_control: libraryControl, name, risk_metadata: riskMedata } = control;
    const { work_phase: workPhase, activity, hazard, unwanted_event: unwantedEvent } = riskMedata || {};

    const changeLabel = tagList.includes("Added") ? "Added By" : "Removed By"
    const tagLabel = tagList.includes("Added") ? "Added" : "Removed"
    const tagClass = tagList.includes("Added") ? "ui label added" : "ui label removed"

    return (
      <div className='logs-desc'>
        {
          libraryControl
          ?
          <div><span className={tagClass}>{tagLabel}</span><LibraryControlItem libraryControl={libraryControl} /></div>
          :
          <div><span className={tagClass}>{tagLabel}</span>{name}</div>
        }

        {
          riskMedata &&
          <div><UnwantedEventDescription className="log-desc-unwanted-event-description" label="Risk Description" workPhase={workPhase} activity={activity} hazard={hazard} unwantedEvent={unwantedEvent}/></div>
        }

        {
          Object.entries(user).length !== 0
          ?
          <React.Fragment>
            {
              (firstName && lastName)
              ?
              <div><label>{changeLabel}: </label><span>{firstName} {lastName} ({email})</span></div>
              :
              <div><label>{changeLabel}: </label><span>{email}</span></div>
            }
          </React.Fragment>
          :
          <div><label>{changeLabel}: </label><span>The System</span></div>
        }
        
      </div>
    )
  }

  return (
    <Draggable handle=".default-template-control-logs-header">
      <div className="default-template-control-logs">
        <div className="default-template-control-logs-header">
          <i className="delete icon" onClick={ props.onClose }></i>
          <div className="default-template-control-logs-instructions">
            <div className="default-template-control-logs-instructions-header">{getText("Default Template Control - Change Logs")}</div>
            <div className="default-template-control-logs-instructions-desc">{getText("The following is a list of default template controls that were added or removed in the template. And the system has automatically applied this to this plan.")}</div>
          </div>
        </div>
        <InfiniteScroll
          dataLength={logs.length}
          next={setNewPage}
          hasMore={true}
          height={1}
        >
          <div className="default-template-control-logs-content">
            { 
              logs && logs.length > 0 ?
              <table className="table default-template-control-logs-table">
                <thead>
                  <tr>
                    <th className="date-header">{getText("Date Changed")}</th>
                    <th className="description-header">{getText("Control Changes")}</th>
                    <th className="actions-header"></th>
                  </tr>
                </thead>
                <tbody>
                  {
                    logs.map((log, index)=>{
                      const logDescription = createLogDescription(log)
                      return (
                        <tr key={index}>
                          <td>{ moment(log.created_at).format("DD MMM YYYY hh:mm A") }</td>
                          <td>{ logDescription }</td>
                          <td><a className="mark-as-reviewed default-template-control-logs-mark-as-reviewed" onClick={ (evt) => markAsReviewed(log.id) }>{getText("Mark as reviewed")}</a></td>
                        </tr>
                      )
                    })
                  }

                </tbody>
              </table>
              :
              <span className="no-records-found">{getText("No changes found")}</span>
            }
          </div>
        </InfiniteScroll>
      </div>
    </Draggable>
  );
}

export default PlanDefaultTemplateControlLogsModal;



// WEBPACK FOOTER //
// ./src/views/plan_default_template_control_logs/plan_default_template_control_logs_modal.js